var $ = require('jquery');

$(function () {
    $('.masonry-grid-with-filter').each(function () {
        var viewMoreButton,
            currentPage,
            previousGridLength,
            servicesFilters,
            industriesFilters,
            publicationsFilters,
            insightsSubjectsFilters,
            itemTypesFilters,
            locationsFilters,
            authorCategorizationFilters,
            makeRequest,
            getFilterValues,
            dateDesc,
            updateClearLinkVisibility,
            clearLink,
            scrollToTop,
            uncheckAllFilterCheckboxes,
            clearAllFilters,
            clearAllFiltersText,
            initFilterGroups,
            applySelectedFiltersVisibility,
            filterDropdownCheckboxes,
            updateSelectedFilters,
            updateViewMoreBtnVisibility,
            isExperienceEditor,
            ajaxTimer;

        // settings
        var dateDesc = true;
        var apiUrlGetGrid = '/api/sitecore/FilteredGrid/GetGrid';

        // end settings
        var currentModule = $(this);

        var FilterCheckboxCollection = function () {
            return {
                services: null,
                industries: null,
                publications: null,
                insightsSubjects: null,
                itemTypes: null,
                locations: null,
                authorCategorization: null
            };
        }

        filterDropdownCheckboxes = new FilterCheckboxCollection();
        filterDropdownCheckboxes.services = currentModule.find('[data-services]');
        filterDropdownCheckboxes.industries = currentModule.find('[data-industries]');
        filterDropdownCheckboxes.publications = currentModule.find('[data-publications]');
        filterDropdownCheckboxes.insightsSubjects = currentModule.find('[data-insightssubjects]');
        filterDropdownCheckboxes.itemTypes = currentModule.find('[data-itemtypes]');
        filterDropdownCheckboxes.locations = currentModule.find('[data-locations]');
        filterDropdownCheckboxes.authorCategorization = currentModule.find('[data-authorcategorization]');

        var gridContainer = currentModule.find('.masonry-grid-container');
        var datasourceId = currentModule.attr('data-context-item');
        var language = currentModule.attr('data-language');
        var isNormal = currentModule.attr('data-is-normal');
        var clearAllFiltersText = currentModule.attr('data-clear-filters-text');
        clearLink = currentModule.find('[data-clear-filters]');

        viewMoreButton = currentModule.find('.view-more');
        currentPage = 0;

        var init = function () {
            applySelectedFiltersVisibility();
            servicesFilters = getFilterValues(filterDropdownCheckboxes.services);
            industriesFilters = getFilterValues(filterDropdownCheckboxes.industries);
            publicationsFilters = getFilterValues(filterDropdownCheckboxes.publications);
            insightsSubjectsFilters = getFilterValues(filterDropdownCheckboxes.insightsSubjects);
            itemTypesFilters = getFilterValues(filterDropdownCheckboxes.itemTypes);
            locationsFilters = getFilterValues(filterDropdownCheckboxes.locations);
            authorCategorizationFilters = getFilterValues(filterDropdownCheckboxes.authorCategorization);
            // Firefox preserves checkbox state on reload.
            uncheckAllFilterCheckboxes();
            initFilterGroups();
            updateViewMoreBtnVisibility();
        };

        uncheckAllFilterCheckboxes = function () {
            currentModule.find('input[type=checkbox]:checked').each(function () {
                var me = $(this);
                me.removeAttr('checked');
                me.prop('checked', false);
            });
        };

        initFilterGroups = function () {
            servicesFilters = [];
            industriesFilters = [];
            publicationsFilters = [];
            insightsSubjectsFilters = [];
            itemTypesFilters = [];
            locationsFilters = [];
            authorCategorizationFilters = [];
        };

        clearAllFilters = function () {
            initFilterGroups();
            var me = currentModule.closest('.masonry-grid-with-filter'),
                selectedFiltersBox = me.find('.selected-filters');
            selectedFiltersBox.find('.selected-filters-list').children().addClass('animated fadeOutDown faster');
            window.clearTimeout(ajaxTimer);
            ajaxTimer = window.setTimeout(function() {
                selectedFiltersBox.find('.selected-filters-list').empty();
                currentModule.find('input[type=checkbox]:checked').each(function (index, item) {
                    var $c = $(this);
                    $c.removeAttr('checked');
                    $c.prop('checked', false);
                });
                makeRequest(servicesFilters, industriesFilters, publicationsFilters, insightsSubjectsFilters, itemTypesFilters, locationsFilters, authorCategorizationFilters, 0, dateDesc);
                applySelectedFiltersVisibility();
            }, 500);
        };

        applySelectedFiltersVisibility = function () {
            var me = currentModule.closest('.masonry-grid-with-filter'),
                selectedFiltersBox = me.find('.selected-filters');
            if ( selectedFiltersBox.find('ul').length == 0 ) {
                selectedFiltersBox.append('<ul class="selected-filters-list"></ul>');
            }
            if ( selectedFiltersBox.find('.selected-filters-list').children().length === 0 ) {
                if ( !isExperienceEditor() ) {
                    selectedFiltersBox.addClass('inactive');
                }
            } else {
                selectedFiltersBox.removeClass('inactive');
            }
       };

        updateViewMoreBtnVisibility = function (visible) {
            var me = currentModule.closest('.masonry-grid-with-filter'),
                viewMoreContainer = me.find('.view-more').closest('.row'),
                myGridContainer = me.find('.masonry-grid-container');

            var hidden = (typeof visible !== 'undefined') ? !visible : (myGridContainer.children('.grid-item').length === 0 || myGridContainer.find('.grid-item .inner[data-is-last-page="True"]').length > 0);

            viewMoreContainer.toggleClass('hidden', hidden);
        };

        scrollToTop = function (selector, speed) {
            selector = typeof selector === 'undefined' ? '.grid-table-scrollTop' : selector;
            speed = typeof speed !== 'number' ? 500 : speed;

            $('html, body').animate({
                scrollTop: currentModule.find(selector).offset().top - 100
            }, speed);
        };

        isExperienceEditor = function () {
            return $('html').hasClass('experience-editor');
        };

        makeRequest = function (targetServicesFilters,
            targetIndustriesFilters,
            targetPublicationsFilters,
            targetInsightsSubjectsFilters,
            targetItemTypesFilters,
            targetLocationsFilters,
            targetAuthorCategorizationFilters,
            targetPage, dateSortDesc, append) {
            append = (typeof append === 'undefined') ? false : append;

            var loadingElement = currentModule.find('.loading');
            loadingElement.addClass('show');

            $.ajax({
                type: 'GET',
                url: apiUrlGetGrid,
                traditional: true,
                data: {
                    id: datasourceId,
                    languageName: language,
                    servicesFilters: targetServicesFilters,
                    industriesFilters: targetIndustriesFilters,
                    publicationsFilters: targetPublicationsFilters,
                    insightsSubjectsFilters: targetInsightsSubjectsFilters,
                    itemTypesFilters: targetItemTypesFilters,
                    locationsFilters: targetLocationsFilters,
                    authorCategorizationFilters: targetAuthorCategorizationFilters,
                    page: targetPage,
                    isDateDesc: dateSortDesc,
                    enforceNormal: isNormal
                },
                success: function (data) {
                    currentModule.find('.no-results').remove();

                    var hasResults = data.indexOf('<div class=\"no-results\"') === -1;

                    if ( !append ) {
                        gridContainer.empty();
                    } else {
                        previousGridLength = gridContainer.children('.grid-item').length;
                    }
                    if (!hasResults) {
                        if ( !append ) {
                            gridContainer.after(data)
                            updateViewMoreBtnVisibility(false);
                        }
                    } else {
                        gridContainer.append(data);
                    }

                    var selectedFilterCount = (targetServicesFilters.length + targetIndustriesFilters.length + targetPublicationsFilters.length + targetInsightsSubjectsFilters.length + targetItemTypesFilters.length + targetLocationsFilters.length + targetAuthorCategorizationFilters.length);

                    gridContainer.find('.grid-item').each(function(index, item) {

                        /* Update individual grid item classes based on their indexes */
                        switch(index) {
                            case 0:
                                if ( selectedFilterCount === 0 ) {
                                    $(this).addClass('featured-item');
                                } else {
                                    $(this).addClass('grid-sizer');
                                }
                                break;
                            case 1:
                                if ( selectedFilterCount === 0 ) {
                                    $(this).addClass('grid-sizer');
                                }
                                break;
                            case 3:
                                $(this).removeClass('fadeInUp').attr('data-animation', 'fadeInLeft');
                                break;
                            case 5:
                                $(this).removeClass('fadeInUp').attr('data-animation', 'fadeInRight');
                                break;
                            default:
                                $(this).removeClass('fadeInUp').attr('data-animation', 'fadeInUp');
                        }

                        /* Add slight delay to first and last item of each row */
                        if ( index % 3 === 0 ) {
                            $(this).addClass('delay-500ms');
                        } else if ( index % 3 === 2 ) {
                            $(this).addClass('delay-250ms');
                        }
                    });

                    servicesFilters = targetServicesFilters;
                    industriesFilters = targetIndustriesFilters;
                    publicationsFilters = targetPublicationsFilters;
                    insightsSubjectsFilters = targetInsightsSubjectsFilters;
                    itemTypesFilters = targetItemTypesFilters;
                    locationsFilters = targetLocationsFilters;
                    authorCategorizationFilters = targetAuthorCategorizationFilters;

                    currentPage = (append === true) ? targetPage :0;

                    viewMoreButton.attr('data-page', parseInt(currentPage) + 1);

                    dateDesc = dateSortDesc;
                    loadingElement.removeClass('show');

                    window.MasonryJS.refreshGrid(currentModule);

                    window.clearTimeout(ajaxTimer);
                    window.setTimeout(function () {
                        if (hasResults) {
                            viewMoreButton.attr('disabled', false);
                            updateViewMoreBtnVisibility();
                        }
                        if ( !append ) {
                            scrollToTop();
                        }
                        $(window).trigger('scroll');
                    }, 450);
                },
                error: function () {
                },
                complete: function () {
                }
            });
        };

        getFilterValues = function (element) {
            const checkboxes = element.find('input[type="checkbox"]');
            const filteredCheckboxes = checkboxes.filter(':checked');
            var ids = [];
            filteredCheckboxes.each(function () {
                ids.push($(this).attr('data-id'));
            });
            return ids;
        };

        updateSelectedFilters = function () {
            var me = currentModule.closest('.masonry-grid-with-filter'),
                selectedFiltersBox = me.find('.selected-filters'),
                dropdownFiltersBox = me.find('.dropdown-filter-list');

            if (!!getFilterValues(filterDropdownCheckboxes.services).length ||
                !!getFilterValues(filterDropdownCheckboxes.industries).length ||
                !!getFilterValues(filterDropdownCheckboxes.publications).length ||
                !!getFilterValues(filterDropdownCheckboxes.insightsSubjects).length ||
                !!getFilterValues(filterDropdownCheckboxes.itemTypes).length ||
                !!getFilterValues(filterDropdownCheckboxes.locations).length ||
                !!getFilterValues(filterDropdownCheckboxes.authorCategorization).length) {
                selectedFiltersBox.removeClass('inactive');
                var activeFiltersList = selectedFiltersBox.find('.selected-filters-list').empty();
                var filteredCheckboxes = dropdownFiltersBox.find('input[type="checkbox"]').filter(':checked');

                filteredCheckboxes.each(function () {
                    var id = $(this).attr('data-id'),
                        name = $(this).next().text().trim(),
                        listItem = $('<li class="selected-filter-item" data-input-id="' + id + '" title="' + name + '">' + name + '</li>');

                    listItem.on('click', function() {
                        var $item = $(this);
                        var id = $(this).data('input-id'),
                            checkbox = dropdownFiltersBox.find('input[type="checkbox"][data-id="'+id+'"]');
                        $item.addClass('animated fadeOutUp animated faster');
                        window.setTimeout(function() {
                            checkbox.click().prop('checked', false).trigger('change');
                        }, 500);
                    });
                    activeFiltersList.append(listItem)
                });
                if ( activeFiltersList.find('.clear-filter').length === 0 ) {
                    var clearBtn = $('<li class="selected-filter-item clear-filter" title="' + clearAllFiltersText + '">' + clearAllFiltersText + '</li>');
                    clearBtn.on('click', function() {
                       clearAllFilters();
                    });
                    activeFiltersList.append(clearBtn);
                }
            } else {
                if ( !isExperienceEditor() ) {
                    selectedFiltersBox.addClass('inactive');
                }
            }
        };

        updateClearLinkVisibility = function () {
            if (!!getFilterValues(filterDropdownCheckboxes.services).length ||
                !!getFilterValues(filterDropdownCheckboxes.industries).length ||
                !!getFilterValues(filterDropdownCheckboxes.publications).length ||
                !!getFilterValues(filterDropdownCheckboxes.insightsSubjects).length ||
                !!getFilterValues(filterDropdownCheckboxes.itemTypes).length ||
                !!getFilterValues(filterDropdownCheckboxes.locations).length ||
                !!getFilterValues(filterDropdownCheckboxes.authorCategorization).length) {
                clearLink.show();
            } else {
                clearLink.hide();
            }
        };

        /**
         * Event Listeners
         */

        /* View More Button Events */
        currentModule.on('click', '.view-more', function (e) {
            var $me = $(e.target);
            const targetPage = parseInt($(e.target).attr('data-page'), 10);
            if (Number.isInteger(targetPage) && targetPage !== currentPage) {
                $me.attr('disabled', true);
                makeRequest(servicesFilters, industriesFilters, publicationsFilters, insightsSubjectsFilters, itemTypesFilters, locationsFilters, authorCategorizationFilters, targetPage, dateDesc, true);
            }
        });

        /* Filter Selection Change Events */
        filterDropdownCheckboxes.services.on('input', 'input[type="checkbox"]', function () {
            makeRequest(getFilterValues(filterDropdownCheckboxes.services), industriesFilters, publicationsFilters, insightsSubjectsFilters, itemTypesFilters, locationsFilters, authorCategorizationFilters, 0, dateDesc);
            updateClearLinkVisibility();
            updateSelectedFilters();
        });
        filterDropdownCheckboxes.industries.on('input', 'input[type="checkbox"]', function () {
            makeRequest(servicesFilters, getFilterValues(filterDropdownCheckboxes.industries), publicationsFilters, insightsSubjectsFilters, itemTypesFilters, locationsFilters, authorCategorizationFilters, 0, dateDesc);
            updateClearLinkVisibility();
            updateSelectedFilters();
        });
        filterDropdownCheckboxes.publications.on('input', 'input[type="checkbox"]', function () {
            makeRequest(servicesFilters, industriesFilters, getFilterValues(filterDropdownCheckboxes.publications), insightsSubjectsFilters, itemTypesFilters, locationsFilters, authorCategorizationFilters, 0, dateDesc);
            updateClearLinkVisibility();
            updateSelectedFilters();
        });
        filterDropdownCheckboxes.insightsSubjects.on('input', 'input[type="checkbox"]', function () {
            makeRequest(servicesFilters, industriesFilters, publicationsFilters, getFilterValues(filterDropdownCheckboxes.insightsSubjects), itemTypesFilters, locationsFilters, authorCategorizationFilters, 0, dateDesc);
            updateClearLinkVisibility();
            updateSelectedFilters();
        });
        filterDropdownCheckboxes.itemTypes.on('input', 'input[type="checkbox"]', function () {
            makeRequest(servicesFilters, industriesFilters, publicationsFilters, insightsSubjectsFilters, getFilterValues(filterDropdownCheckboxes.itemTypes), locationsFilters, authorCategorizationFilters, 0, dateDesc);
            updateClearLinkVisibility();
            updateSelectedFilters();
        });
        filterDropdownCheckboxes.locations.on('input', 'input[type="checkbox"]', function () {
            makeRequest(servicesFilters, industriesFilters, publicationsFilters, insightsSubjectsFilters, itemTypesFilters, getFilterValues(filterDropdownCheckboxes.locations), authorCategorizationFilters, 0, dateDesc);
            updateClearLinkVisibility();
            updateSelectedFilters();
        });
        filterDropdownCheckboxes.authorCategorization.on('input', 'input[type="checkbox"]', function () {
            makeRequest(servicesFilters, industriesFilters, publicationsFilters, insightsSubjectsFilters, itemTypesFilters, locationsFilters, getFilterValues(filterDropdownCheckboxes.authorCategorization), 0, dateDesc);
            updateClearLinkVisibility();
            updateSelectedFilters();
        });

        /* Clear Filters Button Event */
        clearLink.on('click', function () {
            uncheckAllFilterCheckboxes();
            makeRequest(getFilterValues(filterDropdownCheckboxes.services), getFilterValues(filterDropdownCheckboxes.industries), getFilterValues(filterDropdownCheckboxes.publications), getFilterValues(filterDropdownCheckboxes.insightsSubjects), getFilterValues(filterDropdownCheckboxes.itemTypes), getFilterValues(filterDropdownCheckboxes.locations), getFilterValues(filterDropdownCheckboxes.authorCategorization), 0, dateDesc);
            updateClearLinkVisibility();
            updateSelectedFilters();
        });

        init();

    });
});
